<template>
    <van-popup v-model="popupShow" :close-on-click-overlay="false" class="popUp" position="right">
        <div class="order-form">
            <div class="close-btn">
                <van-icon name="cross" @click="close" />
            </div>

            <div class="time-wrap">
                <span>下单倒计时：</span>
                <van-count-down :time="timeout" format="mm 分 ss 秒" />
            </div>

            <div class="select">
                <div class="select-item">
                    <div class="info">
                        <div class="cover">
                            <img :src="goodsInfo.cover" alt="" />
                        </div>

                        <div class="price" v-if="this.goodsInfo && this.goodsInfo.skuList && getSku()">
                            <span>{{ getSku().name }}</span>
                            <span>￥</span>

                            <span>{{ getSku().price }}</span>
                        </div>
                    </div>
                </div>

                <!-- <div class="select-item">
                    <span class="label">规格</span>
                    <div class="remark" ref="remark" v-if="goodsInfo.remark">
                      <van-dropdown-menu active-color="#ff991d">
                            <van-dropdown-item v-model="remark" :options="option" />
                        </van-dropdown-menu>
                    </div>
                  <span class="label">{{ option[this.remark].text }}</span>
                  <span class="label">{{ goodsInfo.specStr }}</span>
                </div> -->
                <!-- <div class="checkbox" v-if="goodsInfo.remark">
                    <van-radio-group v-model="remark">
                        <van-radio :name="item.value" v-for="(item, index) in types" :key="index">
                            <div :class="['check-btn', remark == item.value ? 'active' : '']">
                                {{ getType(item.text) }}

                                <span>￥</span>{{ getPrice(item.text) }}
                            </div>
                        </van-radio>
                    </van-radio-group>
                </div> -->
                <div class="select-item">
                    <span class="label">数量</span>
                    <span class="label">
                        <van-stepper v-model="count" disable-input min="1" max="1" v-if="goodsInfo.limit" />
                        <van-stepper v-model="count" v-else />
                    </span>
                </div>
            </div>

            <!-- <div class="title">
          收货地址

          <span class="tips">(下单后三天内发货)</span>
          <span class="tips"> (4月7日统一发货)</span>

      </div> -->

            <div class="form">
                <div class="item">
                    <div class="label">姓名</div>
                    <div class="input">
                        <van-field v-model="receiverName" placeholder="请输入收货人姓名" />
                    </div>
                </div>

                <div class="item">
                    <div class="label">手机号</div>
                    <div class="input">
                        <van-field v-model="phone" type="tel" maxlength="11" placeholder="请输入手机号" />
                    </div>
                </div>
                <div class="flex">
                    <div class="label">收货方式</div>

                    <van-radio-group v-model="receiveType" direction="horizontal" @change="change">
                        <van-radio checked-color="#ff991d" name="1" v-if="!goodsInfo.isSelf">快递</van-radio>
                        <van-radio checked-color="#ff991d" name="2" v-if="goodsInfo.isSelf">自提</van-radio>
                        <!-- <van-radio checked-color="#ff991d" name="2">自提</van-radio> -->
                    </van-radio-group>
                </div>

                <div class="item" v-if="receiveType == 1">
                    <div class="label">地区</div>
                    <div class="input">
                        <!--                        <van-field  v-model= "address"  readonly placeholder = "请选择所在地区" @click = "click"-->
                        <van-field
                            :value="address"
                            readonly
                            placeholder="请选择所在地区"
                            @click="click"
                            type="textarea"
                            autosize
                            rows="1"
                        />
                        <van-popup v-model="show" round position="bottom">
                            <van-cascader
                                v-model="cascaderValue"
                                title="请选择所在地区"
                                :options="options"
                                @close="show = false"
                                @finish="onFinish"
                                :field-names="fieldNames"
                            />
                        </van-popup>
                    </div>
                </div>

                <div class="item">
                    <div class="label">地址</div>
                    <div class="input">
                        <van-field
                            v-if="!goodsInfo.isSelf"
                            v-model="addressDetail"
                            placeholder="请输入详细地址"
                            type="textarea"
                            autosize
                            rows="1"
                        />
                        <van-field
                            v-if="goodsInfo.isSelf"
                            v-model="detail"
                            placeholder="请输入详细地址"
                            readonly
                            type="textarea"
                            autosize
                            rows="1"
                        />
                    </div>
                </div>

                <div class="btn-wrap">
                    <div class="btn" @click="goPay">
                        <span>提交订单</span>
                    </div>
                </div>

                <!-- <div class="tips">疫情管控地区谨慎下单</div> -->
            </div>
        </div>
    </van-popup>
</template>

<script>
import { confirmOrder, cancelOrder } from '@/api/home'
import { Popup } from 'vant'
import { areaList } from '@vant/area-data'
import { options0 } from '@/utils/area-pguo'
// import { options0 } from '@/utils/area-all'
import { options1 } from '@/utils/area-zjs'
import { options2 } from '@/utils/area-hz'
import { options3 } from '@/utils/area-hz-wx&nth'
import { localGetAddress, localSetAddress } from '@/utils/storage'
import { mapState } from 'vuex'

export default {
    name: 'PasswardForm',
    props: {
        orderId: Number,
        timeout: Number,
        checked: Number,
        // goodsInfo: Object,
    },
    data() {
        return {
            popupShow: false,
            show: false,
            areaList,
            count: 1,
            address: '',
            addressDetail: '',
            detail: '',
            phone: localGetAddress('phone'),
            receiverName: localGetAddress('receiverName'),
            //自提2 快递1
            receiveType: '1',
            timer: null,
            remark: 1,
            fieldValue: '',
            cascaderValue: '浙江省',
            fieldNames: {
                text: 'label',
                value: 'value',
                children: 'children',
            },
        }
    },
    components: {
        'van-popup': Popup,
    },

    watch: {
        goodsInfo() {
            this.receiveType = this.goodsInfo.isSelf ? '2' : '1'
            this.addressDetail = this.goodsInfo.isSelf ? this.goodsInfo.selfAddress : localGetAddress('addressDetail')
            this.address = this.goodsInfo.isSelf ? '浙江省 湖州市 吴兴区' : localGetAddress('address')
            this.detail = this.address + ' ' + this.addressDetail
        },

        // popupShow() {
        //     if (this.popupShow) {
        //         this.remark = this.checked
        //     }
        // },
    },

    computed: {
        ...mapState(['goodsInfo']),
        options() {
            const optionsObj = {
                1: options1,
                2: options2,
                3: options3,
            }
            let type = this.goodsInfo.transportType
            if (!type) return options0
            return optionsObj[type]
        },

        option() {
            let arr = [{ text: '请选择类型', value: 0 }]
            if (this.goodsInfo.remark) {
                this.goodsInfo.remark.split(',').map((v, i) => {
                    arr.push({ text: v.split('#')[0] + '(' + v.split('#')[1] + '元)', value: i + 1 })
                })
            }

            return arr
        },
        types() {
            let arr = []

            if (this.goodsInfo.remark) {
                this.goodsInfo.remark.split(',').map((v, i) => {
                    arr.push({ text: v, value: i + 1 })
                })
            }
            return arr
        },
        remarkText() {
            if (this.goodsInfo.remark) {
                let arr = []

                this.goodsInfo.remark.split(',').map((v, i) => {
                    arr.push({ text: v, value: i + 1 })
                })

                let ret = arr.find((item) => {
                    return item.value == this.remark
                })

                return this.remark ? ret.text : ''
            }
        },
    },
    methods: {
        getType(str) {
            return str.split('#')[0] || ''
        },
        getPrice(str) {
            return str.split('#')[1] || ''
        },
        getSku() {
            if (this.goodsInfo && this.goodsInfo.skuList) {
                return this.goodsInfo.skuList.find((item) => {
                    return item.id == this.checked
                })
            }
            return { name: '', price: '' }
        },
        goPay(item) {
            if (this.goodsInfo.remark && !this.remark) {
                return this.$toast.fail('请选择类型')
            } else if (!this.receiverName) {
                return this.$toast.fail('请填写收货人姓名')
            } else if (this.phone.length !== 11) {
                return this.$toast.fail('请输入正确的手机号')
            }
            this.confirmOrder()
        },

        click() {
            if (this.goodsInfo.transportType === 0) {
                this.cascaderValue = ''
            }
            this.show = true
        },
        onFinish({ selectedOptions }) {
            this.show = false
            this.address = selectedOptions.map((option) => option.label).join(' ')
        },
        close() {
            console.log(this.orderId)

            if (this.orderId) {
                this.$dialog
                    .confirm({
                        title: '提醒',
                        message: '是否取消订单',
                    })
                    .then(() => {
                        this.cancelOrder()
                    })
            } else {
                this.popupShow = false
            }
        },

        confirm(e) {
            console.log(e)
            this.address = e[0].name + e[1].name + e[2].name
            this.show = false
        },

        change(e) {},

        async confirmOrder() {
            const { data: res } = await confirmOrder({
                address: this.address,
                addressDetail: this.addressDetail,
                count: this.count,
                m2oId: this.$store.state.nthUserInfo.userid,
                orderId: this.orderId,
                phone: this.phone,
                receiverName: this.receiverName,
                receiveType: this.receiveType,
                remark: this.remarkText,
            })
            // 储存数据本地
            localSetAddress({
                address: this.address,
                addressDetail: this.addressDetail,
                phone: this.phone,
                receiverName: this.receiverName,
            })

            if (res.code === 200) {
                await this.$store.dispatch('awaitBuyTimer', res.data.timeout)
                await this.$router.push({
                    path: '/pay',
                    query: {
                        data: JSON.stringify(res.data),
                        checked:this.checked
                    },
                })
            }
        },

        async cancelOrder() {
            const { data: res } = await cancelOrder({
                m2oId: this.$store.state.nthUserInfo.userid,
                orderId: this.orderId,
            })
            if (res.code === 200) {
                this.$toast.fail('订单已取消')
                this.$store.commit('setIsGet', false)
                await this.$store.dispatch('awaitBuyTimer', 0)
                // this.$store.commit("")
                this.popupShow = false
            } else {
                this.popupShow = false
            }
        },
    },
}
</script>

<style scoped lang="less">
/deep/ .van-popup--center {
    top: 55%;
}
.order-form {
    height: 100vh;
    padding: 20px;

    overflow: hidden;
    overflow-y: auto;
    padding-top: 80px;
    padding-bottom: 100px;
}
.info {
    display: flex;

    align-items: center;
    margin-bottom: 30px;
    .cover {
        width: 80px;
        height: 50px;
        margin-right: 10px;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 5px;
        }
    }
}

.popUp {
    width: 100%;
    // box-shadow: 0px 8px 19px #dedede;

    // max-height: 90%;
    // position: relative;

    .time-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ff991d;

        .van-count-down {
            color: #ff991d;
        }
    }

    .close-btn {
        position: absolute;
        right: 10px;
        top: 80px;
        z-index: 1;
        color: #c8c9cc;
        font-size: 22px;
        cursor: pointer;
    }

    .title {
        font-size: 14px;

        color: #333;
        margin: 10px 0;
    }

    .select {
        margin-bottom: 10px;
        // background: #f9f9f9;
        padding: 10px;

        width: 100%;

        .select-item {
            display: flex;
            width: 100%;

            justify-content: space-between;
            margin-bottom: 10px;
            // align-items: center;

            .label {
                color: #666;
                // width: 40px;
            }

            .value {
                flex: 1;
                margin-left: 10px;

                .van-radio-group--horizontal {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: flex;
                    justify-content: flex-end;
                    -webkit-flex-wrap: wrap;
                    flex-wrap: wrap;
                }
            }
        }

        .select-item:nth-child(1) {
            margin-bottom: 15px;
        }
    }
    .checkbox {
        display: flex;
        .active {
            background: #fffaee !important;
            border: 1px solid #fbd13d;
            // color: #FBD13D;
        }
        .check-btn {
            background: #f5f6f8;
            flex: 1;
            padding: 10px;
            text-align: center;
            width: 100%;
            border-radius: 4px;

            // line-height: 40px;
            // background: #f5f6f8;
        }
        .van-radio-group {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }
        .van-radio {
            // flex: 1;
            width: 300px;
            margin-right: 10px;
            margin-bottom: 10px;
        }
        /deep/.van-radio__icon {
            width: 0 !important;
        }
        /deep/.van-icon {
            display: block;
            box-sizing: border-box;
            width: 0 !important;
            height: 0 !important;
            color: transparent;
            font-size: 0.8em;
            line-height: 1.25;
            text-align: center;
            border: none;
            width: 100%;
        }
        /deep/.van-radio__label {
            margin: 0;
            color: #323233;
            line-height: 0.53333rem;
            width: 100%;
        }
    }

    .remark {
        width: 200px;
        /deep/ .van-dropdown-menu__bar {
            /* position: relative; */
            display: -webkit-box;
            display: -webkit-flex;
            display: flex;
            height: 1.28rem;
            // background-color: #f2f2f2;
            box-shadow: none;
        }

        /deep/ .van-dropdown-item--down {
            top: 200px !important;
            bottom: 0;
        }
    }

    .form {
        .item {
            display: flex;

            justify-content: space-between;
            align-items: center;

            .label {
                width: 70px;
                color: #666;

                // text-align: justify;
            }

            .input {
                /deep/ .van-field__control {
                    display: block;
                    box-sizing: border-box;
                    width: 100%;
                    min-width: 0;
                    margin: 0;
                    padding: 10px;
                    color: #323233;
                    line-height: inherit;
                    text-align: left;
                    background-color: #eee;
                    border: 0;
                    resize: none;
                }
            }

            .input {
                flex: 1;
            }
        }
    }

    .tips {
        font-size: 12px;
        font-family: PingFang;
        font-weight: 500;
        color: #ff991d;
        // margin: 42px auto 0;
        text-align: center;

        a {
            color: #999999;
        }
    }

    .btn-wrap {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;

        justify-content: space-between;
        align-items: center;
        background: #fff;
        padding: 10px;

        .btn {
            width: 94%;
            line-height: 40px;

            background: #ff991d;
            border-radius: 20px;

            text-align: center;
            color: #fff;
            display: flex;

            justify-content: center;
            align-items: center;
            margin: 15px 10px;
        }

        .btn-cancel {
            background: #fff;
            border-radius: 20px;
            border: 1px solid #ff991d;
            text-align: center;
            color: #ff991d;
        }
    }
}

.van-cell {
    padding: 4px 0;
}

.flex {
    display: flex;

    align-items: center;
    margin: 10px 0;

    .label {
        width: 70px;
        color: #666;

        // text-align: justify;
    }
}
</style>
